import * as i0 from '@angular/core';
import { Injectable, Inject, Component, Input, NgModule } from '@angular/core';
import * as i2 from '@upr-web-primer/geolocation';
import * as i3 from '@angular/common';
import { DOCUMENT, CommonModule } from '@angular/common';
import * as i1 from '@upr-web-primer/app-utils';
import { paramBool, param } from '@upr-web-primer/app-utils';

const COOKIE_SETTING_MODAL_REPLACED_DEFAULTS = {
    onetrust: {
        enabled: paramBool('$onetrust.enabled$'),
        script: param('$onetrust.script$'),
        domain_script: param('$onetrust.domain_script$') || param('$onetrust.domain.script$'),
        hash: param('$onetrust.hash$'),
        cross_origin: param('$onetrust.crossorigin$'),
        privacy_script: param('$onetrust.privacy_script$') || param('$onetrust.privacy.script$'),
        privacy_ids: param('$onetrust.privacy_ids$') || param('$onetrust.privacy.ids$'),
        privacy_geo: param('$onetrust.privacy_geo$') || param('$onetrust.privacy.geo$'),
        privacy_lspa: param('$onetrust.privacy_lspa$') || param('$onetrust.privacy.lspa$'),
    },
};
const COOKIE_SETTING_MODAL_ENV_DEFAULTS = {
    onetrust: {
        enabled: false,
        script: 'https://cdn.cookielaw.org/consent/559c27c5-3072-4758-b72b-64a6c56370bf-test/otSDKStub.js',
        domain_script: '559c27c5-3072-4758-b72b-64a6c56370bf-test',
        hash: '',
        cross_origin: 'anonymous',
        privacy_script: 'https://cdn.cookielaw.org/opt-out/otCCPAiab.js',
        privacy_ids: '',
        privacy_geo: 'US',
        privacy_lspa: 'false',
    },
};

class CookieSettingModalService {
    constructor(document, appEnvSrv, renderer) {
        this.document = document;
        this.appEnvSrv = appEnvSrv;
        this.renderer = renderer;
        this.appEnvSrv.addDefaultValues(COOKIE_SETTING_MODAL_ENV_DEFAULTS, COOKIE_SETTING_MODAL_REPLACED_DEFAULTS);
        this.csmEnvConfig = this.appEnvSrv.getEnvVariables('onetrust');
        this.renderer2 = this.renderer.createRenderer(null, null);
    }
    init(config) {
        this.oneTrustScriptSrc =
            this.csmEnvConfig.script || config?.oneTrustScriptSrc || '';
        this.privacyScriptSrc =
            this.csmEnvConfig.privacy_script || this.privacyScriptSrc || '';
        this.privacyIds = this.csmEnvConfig.privacy_ids || config?.privacyIds || '';
        this.privacyGeo = this.csmEnvConfig.privacy_geo || config?.privacyGeo || '';
        this.privacyLSPA =
            this.csmEnvConfig.privacy_lspa || config?.privacyLSPA || '';
        this.scriptDataDomainValue =
            this.csmEnvConfig.domain_script || config?.scriptDataDomainValue || '';
        this.scriptIntegrityHash =
            this.csmEnvConfig.hash || config?.scriptIntegrityHash || '';
        this.scriptCrossOrigin =
            this.csmEnvConfig.cross_origin || config?.scriptCrossOrigin || '';
        if (!this.oneTrustScriptSrc ||
            !this.privacyScriptSrc ||
            !this.scriptDataDomainValue ||
            !this.scriptIntegrityHash) {
            return;
        }
        this.setCookieSettingModalScript();
    }
    setCookieSettingModalScript() {
        const oneTrustScript = this.renderer2.createElement('script');
        const privacyCookie = this.renderer2.createElement('script');
        oneTrustScript.src = this.oneTrustScriptSrc;
        oneTrustScript.type = 'text/javascript';
        oneTrustScript.crossOrigin = this.scriptCrossOrigin;
        oneTrustScript.integrity = this.scriptIntegrityHash;
        oneTrustScript.setAttribute('data-domain-script', this.scriptDataDomainValue);
        privacyCookie.src = this.privacyScriptSrc;
        privacyCookie.setAttribute('ccpa-opt-out-ids', this.privacyIds);
        privacyCookie.setAttribute('ccpa-opt-out-geo', this.privacyGeo);
        privacyCookie.setAttribute('ccpa-opt-out-lspa', this.privacyLSPA);
        this.renderer2.appendChild(this.document.head, privacyCookie);
        this.renderer2.appendChild(this.document.head, oneTrustScript);
    }
}
CookieSettingModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalService, deps: [{ token: DOCUMENT }, { token: i1.AppEnvironmentService }, { token: i0.RendererFactory2 }], target: i0.ɵɵFactoryTarget.Injectable });
CookieSettingModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1.AppEnvironmentService }, { type: i0.RendererFactory2 }]; } });

class CookieSettingModalComponent {
    constructor(cookieSettingModalService, geolocationService) {
        this.cookieSettingModalService = cookieSettingModalService;
        this.geolocationService = geolocationService;
        this.enableCookieSettingModal = false;
        this.country =
            this.geolocationService.getGeoCountry().toLowerCase() || 'us';
    }
    ngOnInit() {
        if (this.isEnabled()) {
            this.cookieSettingEnabled = true;
            this.cookieSettingModalService.init({
                enableCookieSettingModal: this.enableCookieSettingModal,
                oneTrustScriptSrc: this.oneTrustScriptSrc,
                privacyScriptSrc: this.privacyScriptSrc,
                privacyIds: this.privacyIds,
                privacyGeo: this.privacyGeo,
                privacyLSPA: this.privacyLSPA,
                scriptDataDomainValue: this.scriptDataDomainValue,
                scriptIntegrityHash: this.scriptIntegrityHash,
                scriptCrossOrigin: this.scriptCrossOrigin,
            });
        }
    }
    isEnabled() {
        return ((this.cookieSettingModalService.csmEnvConfig.enabled ||
            this.enableCookieSettingModal) &&
            this.target === 'Modal - Cookie Settings');
    }
}
CookieSettingModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalComponent, deps: [{ token: CookieSettingModalService }, { token: i2.GeolocationService }], target: i0.ɵɵFactoryTarget.Component });
CookieSettingModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: CookieSettingModalComponent, selector: "upr-cookie-setting-modal", inputs: { target: "target", buttonText: "buttonText", icon: "icon", enableCookieSettingModal: "enableCookieSettingModal", oneTrustScriptSrc: "oneTrustScriptSrc", privacyScriptSrc: "privacyScriptSrc", privacyIds: "privacyIds", privacyGeo: "privacyGeo", privacyLSPA: "privacyLSPA", scriptDataDomainValue: "scriptDataDomainValue", scriptIntegrityHash: "scriptIntegrityHash", scriptCrossOrigin: "scriptCrossOrigin" }, ngImport: i0, template: `
		<img
			*ngIf="
				icon?.iconSrc &&
				buttonText === icon?.linkText &&
				cookieSettingEnabled &&
				country === 'us'
			"
			[src]="icon?.iconSrc"
			[alt]="icon?.altIcon"
			class="custom-image"
		/>
		<button
			*ngIf="cookieSettingEnabled"
			id="ot-sdk-btn"
			class="ot-sdk-show-settings one-trust-button"
			[innerHTML]="buttonText"
		></button>
	`, isInline: true, styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button{border-color:transparent;font-size:100%;padding:0;color:#0368d9;font-weight:700;align-items:center;word-wrap:break-word;line-height:2.4;display:flex}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button:hover{background-color:transparent;color:#0368d9}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button:after{content:\"\\e603\";font-family:uo_ui-icons!important;font-weight:400;margin-left:2px}.custom-image{height:12px;margin:10px 2px 2px 0}:host{display:flex}\n"], directives: [{ type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'upr-cookie-setting-modal', template: `
		<img
			*ngIf="
				icon?.iconSrc &&
				buttonText === icon?.linkText &&
				cookieSettingEnabled &&
				country === 'us'
			"
			[src]="icon?.iconSrc"
			[alt]="icon?.altIcon"
			class="custom-image"
		/>
		<button
			*ngIf="cookieSettingEnabled"
			id="ot-sdk-btn"
			class="ot-sdk-show-settings one-trust-button"
			[innerHTML]="buttonText"
		></button>
	`, styles: [".outline-style-primary-blue{outline:1px dashed #0368d9;outline-offset:2px}.outline-style-primary-white{outline:1px dashed #fff;outline-offset:2px}.font-12{font-size:12px!important}.font-14{font-size:14px!important}.font-16{font-size:16px!important}.font-18{font-size:18px!important}.font-20{font-size:20px!important}.font-22{font-size:22px!important}.font-24{font-size:24px!important}.font-26{font-size:26px!important}.font-28{font-size:28px!important}.font-30{font-size:30px!important}.font-32{font-size:32px!important}.fade-me-in{animation:fadeIn .25s;-webkit-animation:fadeIn .25s;-moz-animation:fadeIn .25s;-o-animation:fadeIn .25s}@keyframes fadeIn{0%{opacity:0;transform:scale(.95)}to{opacity:1;transform:scale(1)}}@keyframes fadeIn{0%{opacity:0;-webkit-transform:scale(.95)}to{opacity:1;-webkit-transform:scale(1)}}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button{border-color:transparent;font-size:100%;padding:0;color:#0368d9;font-weight:700;align-items:center;word-wrap:break-word;line-height:2.4;display:flex}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button:hover{background-color:transparent;color:#0368d9}#ot-sdk-btn.ot-sdk-show-settings.one-trust-button:after{content:\"\\e603\";font-family:uo_ui-icons!important;font-weight:400;margin-left:2px}.custom-image{height:12px;margin:10px 2px 2px 0}:host{display:flex}\n"] }]
        }], ctorParameters: function () { return [{ type: CookieSettingModalService }, { type: i2.GeolocationService }]; }, propDecorators: { target: [{
                type: Input
            }], buttonText: [{
                type: Input
            }], icon: [{
                type: Input
            }], enableCookieSettingModal: [{
                type: Input
            }], oneTrustScriptSrc: [{
                type: Input
            }], privacyScriptSrc: [{
                type: Input
            }], privacyIds: [{
                type: Input
            }], privacyGeo: [{
                type: Input
            }], privacyLSPA: [{
                type: Input
            }], scriptDataDomainValue: [{
                type: Input
            }], scriptIntegrityHash: [{
                type: Input
            }], scriptCrossOrigin: [{
                type: Input
            }] } });

class CookieSettingModalModule {
}
CookieSettingModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
CookieSettingModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalModule, declarations: [CookieSettingModalComponent], imports: [CommonModule], exports: [CookieSettingModalComponent] });
CookieSettingModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalModule, providers: [CookieSettingModalService], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: CookieSettingModalModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [CookieSettingModalService],
                    declarations: [CookieSettingModalComponent],
                    imports: [CommonModule],
                    exports: [CookieSettingModalComponent],
                }]
        }] });

export { CookieSettingModalComponent, CookieSettingModalModule, CookieSettingModalService };
